import {
  EUnitDetailsFilter,
  IBrilliantDevices,
  IIntegrationsCard,
} from "../../interfaces/interfaces";
import InstallationSettingsCard from "../unitDetails/InstallationSettingsCard";
import {
  BrilliantDevices,
  IntegrationDevices,
} from "../unitDetails/common/CommonUnitDetailsComponents";
import { isDateMoreThanThirtyMinutesOld } from "../../utils/utils";

import ViewMembers from "./ViewMembers";

export interface HomeSmallBodyProps {
  brilliantDevices: IBrilliantDevices;
  currentUnitDetailsFilter: EUnitDetailsFilter;
  propertyId: string;
  integrations: IIntegrationsCard[];
  setShowInviteTenantModal: React.Dispatch<React.SetStateAction<boolean>>;
  openEditTenantModalWizard: () => void;
  setShowHomePasscodeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const HomeSmallBody: React.FC<HomeSmallBodyProps> = ({
  brilliantDevices,
  currentUnitDetailsFilter,
  propertyId,
  integrations,
  setShowInviteTenantModal,
  openEditTenantModalWizard,
  setShowHomePasscodeModal,
}) => {
  const IsEveryControlOffline =
    brilliantDevices.installedBrilliantControls.every((control) =>
      isDateMoreThanThirtyMinutesOld(control.lastKnownCloudSync)
    );
  const showSmallContainerForResidentViewWithNoMargin =
    currentUnitDetailsFilter === EUnitDetailsFilter.residents;
  return (
    <div
      className={`brilliant-container-small ${
        showSmallContainerForResidentViewWithNoMargin
          ? "brilliant-container-small-no-margins"
          : ""
      }`}
      data-testid="brilliant-devices-container"
    >
      {currentUnitDetailsFilter === EUnitDetailsFilter.brilliants && (
        <>
          <BrilliantDevices
            brilliantControls={brilliantDevices.installedBrilliantControls}
            brilliantSwitches={brilliantDevices.installedBrilliantSwitches}
            brilliantPlugs={brilliantDevices.installedBrilliantPlugs}
            isInReconfigState={false}
            isProView
          />

          <div className="brilliant-container-name menu brilliant-container-small-padding">
            Installation Settings
          </div>
          <div className="brilliant-container-cards">
            <div data-testid="reset-installation-card">
              <InstallationSettingsCard
                data={{ settingName: "Home Passcode" }}
                openModalFn={() => {
                  setShowHomePasscodeModal(true);
                }}
              />
            </div>
          </div>
        </>
      )}

      {currentUnitDetailsFilter === EUnitDetailsFilter.integrations && (
        <div data-testid="integration-devices">
          <IntegrationDevices
            integrationDevices={integrations}
            isInReconfigState={false}
            IsEveryControlOffline={IsEveryControlOffline}
          />
        </div>
      )}

      {currentUnitDetailsFilter === EUnitDetailsFilter.residents && (
        <div className="brilliant-container-residents">
          <ViewMembers
            propertyId={propertyId}
            openEditResidentModal={openEditTenantModalWizard}
            setShowInviteTenantModal={setShowInviteTenantModal}
          />
        </div>
      )}
    </div>
  );
};

export default HomeSmallBody;
